import {
  CURRENT_WAIVER_RETRIEVED,
  WAIVER_LOADING_FAILED,
  WAIVER_REQUESTED
} from "../constants";
import fetch from "isomorphic-fetch";

export const getCurrentWaiver = waiverId => async (dispatch, getState) => {
  dispatch({ type: WAIVER_REQUESTED });

  const waiver = await fetch(`${process.env.PUBLIC_URL}/api/waiver/${waiverId}`)
    .then(res => res.json())
    .catch(err =>
      dispatch({
        type: WAIVER_LOADING_FAILED,
        payload: "Waiver Failed To Load."
      })
    );
  const checkWaiver = (w) => {
    const isvalid = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (isvalid.test(w.videoUrl)) {
      return w
    }
    else {
      return Object.assign({}, w, { videoUrl: null })
    }
  }

  dispatch({ type: CURRENT_WAIVER_RETRIEVED, payload: checkWaiver(waiver) });
};
